<template>
  <div class="relative pb-48">
    <div
      class="border p-4 m-4 rounded-lg relative overflow-hidden"
      :class="isIn ? 'bg-orange-100 border-orange-300' : 'bg-sky-100 border-sky-300'"
    >
      <v-icon
        icon="ph:calendar"
        :class="isIn ? 'text-orange-300' : 'text-sky-300'"
        class="text-6xl opacity-50 absolute bottom-3 right-3 rotate-12 scale-[200%]"
      />
      <div class="relative z-10">
        <h1 class="">
          <span class="font-bold text-2xl"> Absensi </span>

          <span class="text-lg mb-2" :class="isIn ? 'text-orange-700' : 'text-sky-700'">
            {{ isIn ? "Masuk" : "Keluar" }}
          </span>
        </h1>
        <div :class="isIn ? 'text-orange-800' : 'text-sky-800'">
          <p class="text-sm">
            Anda akan melakukan absensi
            <span class="font-bold">
              {{ isIn ? "Masuk" : "Keluar" }}
            </span>
          </p>
          <p class="text-sm mt-2">
            <span class="font-bold">Catatan:</span> Lokasi absensi akan otomatis diambil dari GPS perangkat Anda.
          </p>
        </div>
      </div>
    </div>
    <!-- {{ selectedLocation }} -->
    <LocationForm
      title="Pilih lokasi absensi"
      @selected="
        (a) => {
          lokasi = a?.id;
          selectedLocation = a?.coords;
        }
      "
    />
    <MultiPictureForm title="Foto" :minimum="2" @selected="(a) => (foto = a)" />

    <div class="fixed max-w-xl w-full bottom-0 bg-white px-2 py-4 flex items-end shadow-md shadow-primary">
      <div class="w-full pr-2">
        <p v-if="!allDone" class="text-sm text-danger">*Harap isi semua untuk mengirim</p>
      </div>

      <van-button
        :disabled="!allDone"
        :loading="isLoading"
        type="info"
        loading-type="spinner"
        @click="submit"
        class="whitespace-nowrap bg-primary border-none"
      >
        <v-icon icon="material-symbols:send" class="text-2xl mr-1 inline" />
        <span class="ml-2 font-bold">Simpan</span>
      </van-button>
    </div>
  </div>
</template>

<style scoped>
  .animate-flashing {
    animation: flashing 1s infinite;
  }

  @keyframes flashing {
    0% {
      --tw-bg-opacity: 1;
    }
    50% {
      --tw-bg-opacity: 0.1;
    }
    100% {
      --tw-bg-opacity: 1;
    }
  }
</style>

<script>
  import LocationForm from "@/components/Forms/LocationForm.vue";
  // import PictureForm from "@/components/Forms/PictureForm.vue";
  import MultiPictureForm from "@/components/Forms/MultiPictureForm.vue";

  import { location } from "@/states/location";
  import dayjs from "dayjs";
  import { users } from "@/states/user";
  // import { queueManager } from "@/states/local";

  import local from "@/states/local";
  import { deleteUpload } from "@/plugins/axios";

  export default {
    name: "AttendancePage",
    components: {
      // PictureForm,
      LocationForm,
      MultiPictureForm
    },

    data() {
      return {
        isLoading: false,
        lokasi: null,
        foto: [],
        selectedLocation: null,
        tracking: location,
        local,
        users
      };
    },
    props: {
      isIn: {
        type: Boolean,
        default: true
      }
    },

    mounted() {},

    computed: {
      allDone() {
        return this.lokasi && this.foto.isPassLimit;
      }
    },

    methods: {
      async submit() {
        const toasty = this.$toast.loading({ message: "Mengupload foto selfie...", forbidClick: true, duration: 0 });
        this.isLoading = true;

        const processedFoto = [];
        for (const x of this.foto.pictures) {
          const result = await local.processFile(x.picture).catch((err) => {
            console.error(err);
            toasty.clear();
            this.$toast.fail({ message: "Gagal mengupload foto", duration: 5000 });
            this.isLoading = false;
            return null;
          });
          processedFoto.push(result);
        }

        if (processedFoto.some((x) => !x)) {
          deleteUpload(processedFoto)
            .then(() => {
              toasty.clear();
              this.$toast.fail({ message: "Gagal mengupload foto. Coba lagi nanti...", duration: 5000 });
            })
            .catch(() => {});
          toasty.clear();
          this.isLoading = false;
          return;
        }

        console.log(processedFoto);
        toasty.message = "Mengirim data...";

        const coordCurrently = this.tracking;
        console.log(coordCurrently, this.tracking);

        local
          .processData(this.isIn ? "/attendance/assign/in" : "/attendance/assign/out", {
            location: this.lokasi,
            currentLocation: this.hasBypass()
              ? this.selectedLocation
              : [coordCurrently.latitude, coordCurrently.longitude],
            images: processedFoto,
            imageDescriptions: this.foto.pictures.map((x) => x.description)
          })
          .then(() => {
            this.isLoading = false;
            toasty.clear();
            this.$router.go(-1);
          })
          .catch((err) => {
            this.isLoading = false;
            toasty.message = "Gagal mengirim data. Menghapus foto...";
            deleteUpload(processedFoto)
              .then(() => {
                toasty.clear();
                this.$toast.fail({ message: "Gagal mengirim. Coba lagi nanti...", duration: 5000 });
              })
              .catch(() => {});

            console.error(err);
          });
      },
      hasBypass() {
        return this.users.data?.occupationPermission?.includes("explicitNoLocation");
      },
      formatTime(time, format = "HH:mm") {
        return dayjs(time).format(format);
      }
    }
  };
</script>
